import { Box } from '@mui/material';
import { DEFAULT_TENANT_NAME } from 'core/apiClient';

export const makeTenantLabel = ({ name }: { name: Nullable<string> }) => {
  return <Box>{name ?? 'Loading...'}</Box>;
};
